// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a phone suspends the app while it is away, so the gateway socket and polling timers stop.
// Coming back (often from a notification tap) should re-read what is on screen straight away
// instead of waiting for the next timer or for the gateway to reconnect first.

import Window from '@app/features/window/state/Window';
import {reaction} from 'mobx';

/** Runs `callback(awayMs)` each time the window is shown again after being hidden for at least `minAwayMs`. */
export function onForeground(callback: (awayMs: number) => void, minAwayMs = 0): () => void {
	let hiddenAt: number | null = Window.visible ? null : Date.now();
	return reaction(
		() => Window.visible,
		(visible) => {
			if (!visible) {
				hiddenAt = Date.now();
				return;
			}
			if (hiddenAt == null) return;
			const awayMs = Date.now() - hiddenAt;
			hiddenAt = null;
			if (awayMs >= minAwayMs) callback(awayMs);
		},
	);
}
